import Entity from 'lib/Entity';
// @ts-ignore
import OfficeHours from 'entities/OfficeHours';
import Backbone from 'backbone-model';
import { cloneDeep } from 'lodash';

class ChatMember extends Entity {
  parse(response: any) {
    const member = cloneDeep(response);
    member['office_hours'] = OfficeHours.fromJSON(member['office_hours']);
    return member;
  }

  getColor(): string | undefined {
    return this.get('color');
  }

  getFirstName(): string {
    return this.get('first_name');
  }

  getLastName(): string {
    return this.get('last_name');
  }

  getUserId(): number {
    return this.get('id');
  }

  getUuid(): string {
    return this.get('uuid');
  }

  getName(): string {
    return this.get('name');
  }

  getInitials(): string | undefined {
    return this.get('initials');
  }

  getProfilePictureUrl(): string | undefined {
    return this.get('profile_picture_url');
  }

  getSignature(): string | undefined {
    return this.get('signature');
  }

  setName(name: string): Backbone.Model {
    return this.set({ name });
  }

  getRole(): string | undefined {
    return this.get('role');
  }

  getOfficeHours(): OfficeHours {
    return this.get('office_hours');
  }

  isBlocked(): boolean {
    return this.get('blocked');
  }

  getContactabilityStatus(): string {
    return this.get('contactability_status');
  }

  setOfficeHours(hours: OfficeHours) {
    return this.set({ office_hours: hours });
  }

  getChatEligibilityState() {
    return this.get('chat_eligibility_state');
  }

  isEligibleForChat() {
    return this.getChatEligibilityState() === 'eligible';
  }
}

export default ChatMember;
